import React from "react"
import ContentLoader from "react-content-loader"

// https://skeletonreact.com
const VideoPreviewPlaceholder = (props) => (
  <ContentLoader 
    speed={2}
    width={340}
    height={241}
    // viewBox="0 0 340 241"
    backgroundColor="#e4e4e4"
    foregroundColor="#cecece"
    {...props}
  >
    {/* <rect x="0" y="0" rx="15" ry="15" width="340" height="191" /> 
    <rect x="10" y="201" rx="5" ry="5" width="155" height="15" /> 
    <rect x="10" y="226" rx="5" ry="5" width="80" height="15" /> 
    <rect x="170" y="201" rx="5" ry="5" width="142" height="15" /> 
    <rect x="95" y="226" rx="5" ry="5" width="150" height="15" /> 
    <rect x="250" y="226" rx="5" ry="5" width="80" height="15" /> */}

    <rect x="0" y="0" width="340" height="191" /> 
    <rect x="10" y="201" width="155" height="15" /> 
    <rect x="10" y="226" width="80" height="15" /> 
    <rect x="170" y="201" width="142" height="15" /> 
    <rect x="95" y="226" width="150" height="15" /> 
    <rect x="250" y="226" width="80" height="15" />
  </ContentLoader>
)

export default VideoPreviewPlaceholder
